import React from 'react'

const IconFilter = ({ color = '#E11C8E' }) => (
  <svg height="20px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg">
    <g stroke="none" strokeWidth="1" fill={color} fillRule="evenodd">
      <path
        d="M6,4 L6,10 L7,10 L7,12 L6,12 L6,20 L4,20 L4,11.999 L3,12 L3,10 L4,9.999 L4,4 L6,4 Z M13,4 L12.999,15 L14,15 L14,17 L12.999,17 L13,20 L11,20 L10.999,17 L10,17 L10,15 L10.999,15 L11,4 L13,4 Z M20,4 L19.999,7 L21,7 L21,9 L19.999,9 L20,20 L18,20 L17.999,9 L17,9 L17,7 L17.999,6.999 L18,4 L20,4 Z"
        fillRule="nonzero"
      />
    </g>
  </svg>
)

export default IconFilter
